/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { ACCESS_TOKEN_ENDPOINT } from '../../constants/endpoints';

export const fetchAccessToken = async ({ spaceId, sessionToken }) => {
  const URL = ACCESS_TOKEN_ENDPOINT(spaceId);
  const { data } = await axios.get(URL, {
    headers: { 'x-session-token': sessionToken },
  });

  return data;
};
